import React from 'react';
import { ErrorBoundary } from '@/app/components/ErrorBoundary';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/query-client';
import { AuthProvider } from '@/contexts/AuthContext';
import { StoreProvider } from '@/contexts/StoreContext';
import { Toaster } from '@geely/ui';
import { ProtectedRoute } from '@/app/components/ProtectedRoute';

// Admin Pages
import { LoginPage } from '@/app/pages/admin/LoginPage';
import { DashboardPage } from '@/app/pages/admin/dashboard';
import { StoresPage } from '@/app/pages/admin/stores';
import { UsersPage } from '@/app/pages/admin/users';
import { OperatingHoursPage } from '@/app/pages/admin/operating-hours';
import { AppointmentsPage } from '@/app/pages/admin/appointments';
import { ModelsPage } from '@/app/pages/admin/models';

export default function App() {
  return (
    <ErrorBoundary fallback={<p>Ocorreu um erro inesperado. Recarregue a página.</p>}>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
        <StoreProvider>
          <Routes>
            {/* Admin Routes */}
            <Route path="/admin/login" element={<LoginPage />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/stores"
              element={
                <ProtectedRoute requiredRole="admin">
                  <StoresPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute requiredRole="admin">
                  <UsersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/operating-hours"
              element={
                <ProtectedRoute requiredRole="store_admin">
                  <OperatingHoursPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/appointments"
              element={
                <ProtectedRoute requiredRole="store_admin">
                  <AppointmentsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/models"
              element={
                <ProtectedRoute requiredRole="admin">
                  <ModelsPage />
                </ProtectedRoute>
              }
            />

            {/* Redirects */}
            <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
            <Route path="/" element={<Navigate to="/admin/login" replace />} />
            <Route path="*" element={<Navigate to="/admin/login" replace />} />
          </Routes>
          <Toaster />
        </StoreProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
    </ErrorBoundary>
  );
}
